export default __webpack_public_path__ + "static/media/europ.34b0db28.png";